import { System } from 'src/app/@framework/core/clms.fw.dotnet';
import * as Domain from '../Domain';
import * as Common from '../../@framework/common';
import { CLMS  } from 'src/app/@framework/core/clms.fw.common';
import { Joove } from 'src/app/@framework/core/Joove';
import * as moment from 'moment';
import { TranslateService } from '@ngx-translate/core';
import { DataListColumnInfo, DataListColumnItemType, ListDynamicColumnValue } from '@framework/components/DataList/helpers/List.helper.classes';
import { ValueFormat } from '@framework/core/clms.fw.angular';
var numeral = require('numeral');
const VerEx = require('verbal-expressions');


export class InvoiceCancellation  {
    _originalTypeClassName = "zERP.BO.InvoiceCancellation";
constructor(protected translateService: TranslateService = null) {
if (translateService != null) {
InvoiceCancellation.translate = translateService;
}
this.Id = null;
this.CreatedAt = null;
this.Amount = null;
this.Reason = null;
this.AA = null;
this._key = this.Id = 0; 
}

static translate: TranslateService;
_key: any;
private _Id:any;
get Id(): any {
    return this._Id;
  }
set Id(value: any) {
    this._Id = value;
    this._key = value;
  }
CreatedAt:any;
Amount:any;
Reason:any;
AA:any;
CancelledBy:any;
Series:any;
static setCancelledBy = ($this, value) => {
var oldValue = $this.CancelledBy;
$this.CancelledBy = value;
if (value != null) {
}
}
static setSeries = ($this, value) => {
var oldValue = $this.Series;
$this.Series = value;
if (value != null) {
}
}


static IsNew($this: any): boolean {
                if ($this == null) return true;
                return $this.Id == null || $this.Id == 0;
            }


}